import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Images } from "../assets";

const ScrollingCard = ({ id, image, image_type, title, content }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/actualites/${id}`);
  };

  return (
    <div
      className="relative w-full h-full cursor-pointer"
      onClick={handleClick}
    >
      {(image_type ?? "").startsWith("video/") ? (
        <video
          className="w-full h-full object-cover"
          src={image}
          autoPlay
          loop
          muted
          playsInline
        />
      ) : (
        <img src={image} alt={title} className="w-full h-full object-cover" />
      )}
      <div className="absolute w-1/2 flex justify-between items-start bottom-3 left-3 z-10 bg-orange p-3 rounded-xl text-start">
        <div className="flex flex-col gap-1">
          <p className="font-semibold">{title}</p>
          <p className="text-sm">{content[0]?.title}</p>
        </div>
        <img src={Images.STAR} alt={title} className="w-7" />
      </div>
    </div>
  );
};

const ScrollingNews = () => {
  const [newsData, setNewsData] = useState([]);
  const containerRef = useRef(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch("/api/news");
        const data = await response.json();
        if (response.status !== 200) {
          console.error(data.detail || "Failed to fetch news data");
          return;
        }

        setNewsData(data);
      } catch (error) {
        console.error("Error fetching news data:", error);
      }
    };

    fetchNews();
  }, []);

  return (
    <div className="relative w-full mt-10">
      <div
        ref={containerRef}
        className="flex gap-5 h-[40vh] overflow-x-auto scroll-smooth snap-x snap-mandatory"
      >
        {newsData.map((item, index) => (
          <div key={index} className="snap-start min-w-[100vw] xl:min-w-[50%]">
            <ScrollingCard {...item} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScrollingNews;
